import { get, post, delet } from '@/core/h5/request'

// 获取用户信息
export const fetchUserInfo = async (parm) => {
    const { spaceId, userId } = parm
    return get({
        url: `/uic/web/member/detail?spaceId=${spaceId}&userId=${userId}`,
        baseURL: process.env.VUE_APP_BASE_URL,
    })
}

/// 创建文件
export const createFile = (data) => {
    const options = {
        data,
        url: `/file/api/document/new`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return post(options)
}

/// 创建文件夹
export const createFolder = (data) => {
    const options = {
        data,
        url: `/file/api/document/mkdir`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return post(options)
}

/// 获取最近文件列表
export const getRecentFile = (data) => {
    const options = {
        params: data,
        url: '/file/api/document/recent',
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return get(options)
}

/// 获取我的文件列表
export const getMyFile = (data) => {
    const options = {
        params: data,
        url: '/file/api/document/list',
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return get(options)
}

/// 获取知识库列表
export const getWikiList = (data) => {
    const options = {
        params: data,
        url: '/file/api/wiki/space',
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return get(options)
}

// 获得收藏列表
export const getStarList = (data) => {
    const options = {
        params: data,
        url: '/file/api/file/star',
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return get(options)
}

// 置顶知识库
export const starWiki = (wikiSpaceId) => {
    const options = {
        url: `/file/api/wiki/space/star/${wikiSpaceId}`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return post(options)
}

// 取消置顶知识库
export const unStarWiki = (wikiSpaceId) => {
    const options = {
        url: `/file/api/wiki/space/star/${wikiSpaceId}`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return delet(options)
}

// 置顶知识库列表
export const fetchStarWikiList = (data) => {
    const options = {
        params: data,
        url: '/file/api/wiki/space/star',
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return get(options)
}

/// 检查文件重名
export const checkFileName = (data) => {
    const options = {
        data: data,
        url: `/file/api/document/upload/init/name`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return post(options)
}